import React, { useContext } from 'react'
import { EPCRContext } from '../../EPCR'
import FormControlLabel from '@mui/material/FormControlLabel'
import Grid from '@mui/material/Grid'
import Switch from '@mui/material/Switch'

const WasItHS = () => {
  const { formValues, handleChange } = useContext(EPCRContext)

  return (
      <FormControlLabel
        label="Was there a Health and Safety Concern?"
        control={
          <Switch
            checked={formValues?.incident?.healthSafetyConcern}
            color='error'
            onChange={(e) =>
              handleChange({
                moduleName: 'incident',
                field: 'healthSafetyConcern',
                value: e.target.checked,
              })
            }
          />
        }
      />
  )
}

export default WasItHS
